import { Stack } from '@mui/material'
import {
  Inputs,
  useAction,
} from '../../containers/facilityReservationTodayConditionInput/facilityReservationTodayConditionInputService'
import { GContainer, GItem } from '../components/common/grids'
import { Form } from '../components/common/inputs/form'
import { Control } from 'react-hook-form'
import styled from '@emotion/styled'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonL } from '../components/common/buttons/buttonL'
import { BackButton } from '../components/common/buttons/backButton'
import { Dialog } from '../components/common/dialog'
import { ButtonOutlinedS } from '../components/common/buttons/buttonOutlinedS'
import TodayConditionSec from '../components/facilityReservationTodayConditionInput/todayConditionSec'
import SleepSec from '../components/facilityReservationTodayConditionInput/sleepSec'
import DefecationSec from '../components/facilityReservationTodayConditionInput/defecationSec'
import MealSec from '../components/facilityReservationTodayConditionInput/mealSec'
import OtherSec from '../components/facilityReservationTodayConditionInput/otherSec'
import ReservationInfoArea from '../components/facilityReservationTodayConditionInput/reservationInfoArea'
import { translate } from '../../i18n'
import { StepBar } from '../components/common/stepBar'

const MessageBox = styled('div')({
  whiteSpace: 'pre-wrap',
})

export const FacilityReservationTodayConditionInput = () => {
  const {
    // history,
    // reservationNo,
    todayConditionInputDetail,
    todayConditionInputDecodeMst,
    formMethods,
    isCough,
    isRunnyNose,
    isEczema,
    isAllergy,
    isFoodAllergy,
    isMedicine,
    isMood,
    isDisease,
    isVaccine,
    isHospitalVisit,
    isInfection,
    isTodayConditionPoint,
    // isStroll,
    // isLastNightSleep,
    isNap,
    napType,
    defecationTiming,
    isMeal,
    eatingMethod,
    breakfast,
    lunch,
    snack,
    eatingMethodDetail,
    escortType,
    belongings,
    onSubmit,
    isShowNoChange,
    setIsShowNoChange,
    yesNos,
  } = useAction()

  const reservationInfo = todayConditionInputDetail?.reservationInfo
  const todayConditionInputFieldsInfo = todayConditionInputDetail?.todayConditionInputFieldsInfo
  const control: Control<Inputs> = formMethods.control

  // きょうの様子セクションを表示するかの状態を保持するフラグ
  const isViewTodayConditionSec =
    todayConditionInputFieldsInfo &&
    (todayConditionInputFieldsInfo.morningBodyTemperature !== '0' ||
      todayConditionInputFieldsInfo.afterComingBodyTemperature !== '0' ||
      todayConditionInputFieldsInfo.cough !== '0' ||
      todayConditionInputFieldsInfo.runnyNose !== '0' ||
      todayConditionInputFieldsInfo.eczema !== '0' ||
      todayConditionInputFieldsInfo.allergy !== '0' ||
      todayConditionInputFieldsInfo.foodAllergy !== '0' ||
      todayConditionInputFieldsInfo.medicine !== '0' ||
      todayConditionInputFieldsInfo.mood !== '0' ||
      todayConditionInputFieldsInfo.disease !== '0' ||
      todayConditionInputFieldsInfo.vaccine !== '0' ||
      todayConditionInputFieldsInfo.hospitalVisit !== '0' ||
      todayConditionInputFieldsInfo.infection !== '0' ||
      todayConditionInputFieldsInfo.todayConditionPoint !== '0' ||
      todayConditionInputFieldsInfo.stroll !== '0')

  // 睡眠セクションを表示するかの状態を保持するフラグ
  const isViewSleepSec =
    todayConditionInputFieldsInfo &&
    (todayConditionInputFieldsInfo.lastNightSleep !== '0' || todayConditionInputFieldsInfo.nap !== '0')

  // 排便セクションを表示するかの状態を保持するフラグ
  const isViewDefecationSec = todayConditionInputFieldsInfo && todayConditionInputFieldsInfo.defecation !== '0'

  // 食事セクションを表示するかの状態を保持するフラグ
  const isViewMealSec =
    todayConditionInputFieldsInfo &&
    (todayConditionInputFieldsInfo.meal !== '0' || todayConditionInputFieldsInfo.mealDetail !== '0')

  return (
    <>
      <Form onSubmit={onSubmit} formMethods={formMethods}>
        <Stack spacing={2}>
          <GContainer justifyContent={'center'}>
            <GItem xs={12} md={6}>
              <StepBar
                activeStepValue="①"
                stepValueLabels={[
                  { value: '①', label: '必要事項入力' },
                  { value: '②', label: '入力内容確認' },
                  { value: '③', label: '完了' },
                ]}
              />
              {/* ==========予約情報の表示エリア========== */}
              {reservationInfo && <ReservationInfoArea reservationInfo={reservationInfo} />}

              {/* ==========きょうの様子セクション========== */}
              {todayConditionInputFieldsInfo && isViewTodayConditionSec && (
                <TodayConditionSec
                  control={control}
                  todayConditionInputFieldsInfo={todayConditionInputFieldsInfo}
                  isCough={isCough}
                  isRunnyNose={isRunnyNose}
                  isEczema={isEczema}
                  isAllergy={isAllergy}
                  isFoodAllergy={isFoodAllergy}
                  isMedicine={isMedicine}
                  isMood={isMood}
                  isDisease={isDisease}
                  isVaccine={isVaccine}
                  isHospitalVisit={isHospitalVisit}
                  isInfection={isInfection}
                  isTodayConditionPoint={isTodayConditionPoint}
                  yesNos={yesNos}
                />
              )}

              {/* ==========睡眠セクション========== */}
              {todayConditionInputFieldsInfo && todayConditionInputDecodeMst && isViewSleepSec && (
                <SleepSec
                  control={control}
                  todayConditionInputFieldsInfo={todayConditionInputFieldsInfo}
                  napTypeDecodeMst={todayConditionInputDecodeMst.napType}
                  isNap={isNap}
                  napType={napType}
                  yesNos={yesNos}
                />
              )}

              {/* ==========排便セクション========== */}
              {todayConditionInputFieldsInfo && todayConditionInputDecodeMst && isViewDefecationSec && (
                <DefecationSec
                  control={control}
                  todayConditionInputFieldsInfo={todayConditionInputFieldsInfo}
                  defecationTimingDecodeMst={todayConditionInputDecodeMst.defecationTiming}
                  defecationConditionDecodeMst={todayConditionInputDecodeMst.defecationCondition}
                  defecationTiming={defecationTiming}
                />
              )}

              {/* ==========食事セクション========== */}
              {todayConditionInputFieldsInfo && todayConditionInputDecodeMst && isViewMealSec && (
                <MealSec
                  control={control}
                  todayConditionInputFieldsInfo={todayConditionInputFieldsInfo}
                  eatingMethodDecodeMst={todayConditionInputDecodeMst.eatingMethod}
                  amountOfFoodDecodeMst={todayConditionInputDecodeMst.amountOfFood}
                  brestFeedingDetailDecodeMst={todayConditionInputDecodeMst.brestFeedingDetail}
                  isMeal={isMeal}
                  eatingMethod={eatingMethod}
                  breakfast={breakfast}
                  lunch={lunch}
                  snack={snack}
                  eatingMethodDetail={eatingMethodDetail}
                  yesNos={yesNos}
                />
              )}

              {/* ==========その他セクション========== */}
              {todayConditionInputFieldsInfo &&
                todayConditionInputDecodeMst &&
                todayConditionInputDecodeMst.belongings &&
                todayConditionInputDecodeMst.escortType && (
                  <OtherSec
                    control={control}
                    todayConditionInputFieldsInfo={todayConditionInputFieldsInfo}
                    escortTypeDecodeMst={todayConditionInputDecodeMst.escortType}
                    escortType={escortType}
                    belongingsDecodeMst={todayConditionInputDecodeMst.belongings}
                    belongings={belongings}
                  />
                )}
            </GItem>
          </GContainer>

          {/* 画面下部ボタングループ */}
          <BottomButtonGroup>
            <ButtonL type="submit" fullWidth>
              {translate('facilityReservationTodayConditionInput.button.submit')}
            </ButtonL>
            <BackButton />
          </BottomButtonGroup>
        </Stack>
      </Form>

      {/* 変更なしダイアログ */}
      <Dialog
        isOpen={isShowNoChange}
        onClose={() => {
          setIsShowNoChange(false)
        }}
        buttons={
          <>
            <ButtonOutlinedS
              onClick={() => {
                setIsShowNoChange(false)
              }}
            >
              {translate('facilityReservationTodayConditionInput.button.close')}
            </ButtonOutlinedS>
          </>
        }
      >
        <Stack spacing={2}>
          <MessageBox>{translate('facilityReservationTodayConditionInput.text.noChange')}</MessageBox>
          <GContainer></GContainer>
        </Stack>
      </Dialog>
    </>
  )
}
